const shadows = {
  card: '0px 4px 20px 0px #0000000d',
  dropdown: '0px 2px 4px rgba(0,0,0,0.6), 0px 4px 8px rgba(0,0,0,0.6)',
};

export default shadows;
